// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5730) return "static/chunks/44530001-1e375766b3760fa1.js";
	if (chunkId === 8370) return "static/chunks/8370-5737148554b2b925.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2438":"e8308e28306b0d06","5782":"3624ee76114671f2"}[chunkId] + ".js";
};